/* eslint-disable no-debugger */
import { Fragment } from 'react';

import NewClubStaffCertificationLargeGrid from './NewClubRegistrationStaffLargeGrid';

const NewClubRegistrationStaffGrid = ({ state, registrationRoles, onEdit, onDelete }) => {

  return (
    <Fragment>
      <NewClubStaffCertificationLargeGrid state={state} registrationRoles={registrationRoles} onEdit={onEdit} onDelete={onDelete} />
    </Fragment>
  );
};

export default NewClubRegistrationStaffGrid;